module.exports = __webpack_public_path__ + "media/images/ecalls/fausto_video-a8e24515344a4448ea11f0d259b22df9.png";